"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    INVALID_CREDENTIALS: {
        code: '095001',
        description: 'Invalid credentials',
        httpStatus: 401,
        displayToUser: true,
        isRetryable: false,
        errorLevel: 'verbose',
    },
    INVALID_MFA: {
        code: '095002',
        description: 'Invalid 2fa code',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    BANNED_ACCOUNT: {
        code: '095003',
        description: 'Banned account',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    DELETED_ACCOUNT: {
        code: '095004',
        description: 'Deleted account',
        httpStatus: 401,
        displayToUser: true,
        isRetryable: false,
    },
    UNUSABLE_ACCOUNT: {
        code: '095005',
        description: 'Unusable account',
        httpStatus: 403,
        displayToUser: false,
        isRetryable: false,
    },
    SESSION_ALREADY_ACTIVE: {
        code: '095006',
        description: 'Session already active',
        httpStatus: 401,
        displayToUser: true,
        isRetryable: false,
    },
    KOUNT_CONTROL_INVALID_REQUEST: {
        code: '095007',
        description: 'Invalid request to verify login',
        httpStatus: 400,
        displayToUser: true,
        isRetryable: false,
    },
    KOUNT_LOGIN_BLOCKED: {
        code: '095008',
        description: 'Kount blocked login attempt',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    KOUNT_DEVICE_NOT_TRUSTED: {
        code: '095009',
        description: 'Kount device not trusted',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
        errorLevel: 'verbose',
    },
    FACEBOOK_AUTH_INVALID_TOKEN: {
        code: '095010',
        description: 'Facbeook Auth token provided by frontend is invalid',
        httpStatus: 403,
        displayToUser: false,
        isRetryable: false,
    },
    GOOGLE_AUTH_INVALID_TOKEN: {
        code: '095011',
        description: 'Google Auth token provided by frontend is invalid',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    GOOGLE_AUTH_INCOMPLETE_DATA: {
        code: '095012',
        description: 'Google Auth data is incomplete. Profile scope was not granted',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    RESET_PASSWORD_CODE_NOT_FOUND: {
        code: '095013',
        description: 'Reset password code not found',
        httpStatus: 404,
        displayToUser: true,
        isRetryable: false,
    },
    RESET_PASSWORD_CODE_EXPIRED: {
        code: '095014',
        description: 'Reset password expired',
        httpStatus: 410,
        displayToUser: true,
        isRetryable: false,
    },
    USERNAME_NOT_EDITABLE: {
        code: '095015',
        description: 'Username already edited',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    USERNAME_ALREADY_TAKEN: {
        code: '095016',
        description: 'Username already taken',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    APPLE_AUTH_INVALID_TOKEN: {
        code: '095017',
        description: 'Apple Auth token provided by frontend is invalid',
        httpStatus: 403,
        displayToUser: true,
        isRetryable: false,
    },
    PASSWORD_NEEDS_UPDATE: {
        code: '095018',
        description: 'Password needs update',
        httpStatus: 401,
        displayToUser: true,
        isRetryable: false,
    },
};
